import { createFeatureSelector, createSelector } from '@ngrx/store';
import { User } from '../models/user';
import { AppActions, AppActionTypes } from './app.actions';

export interface State {
  app: AppState;
}

export interface AppState {
  currentUser: User;
}

const initialState: AppState = {
  currentUser: new User()
};

const getAppFeatureState = createFeatureSelector<AppState>('app');
export const getCurrentUser = createSelector(getAppFeatureState, state => state.currentUser);

export function reducer(state: AppState = initialState, action: AppActions): AppState {
  switch (action.type) {
    case AppActionTypes.ToggleCurrentUser:
      return { ...state, currentUser: action.payload };
    default:
      return state;
  }
}
